import { useEffect } from 'react';
import { DFPManager } from 'react-dfp';
import { useRouter } from 'next/router';
import Ad from './Ad';
import { AdSizes } from './AdSizes';
import globalValues from '../../static-data/global-values.json';

export default function SponsorAd() {
	const adWrapperClass = 'sponsor-ad-wrapper';
	const adId = 'sponsor-ad';
	const { cesDataAdsSponsorLabel } = globalValues?.data?.corusAdsSettings;
	const adLabel = cesDataAdsSponsorLabel || 'IN PARTNERSHIP WITH';

	const router = useRouter();

	useEffect(() => {
		const displaySponsorAd = (event) => {
			// Find any sponsor ad divs on the page
			const sponsorWrapperDiv = document.querySelector('.sponsor-ad-wrapper');
			if (sponsorWrapperDiv) {
				const slotDiv = sponsorWrapperDiv.querySelector(`#${event.slot.getSlotElementId()}`);
				// Show sponsor ad div only if an adslot was fetched and rendered
				if (!event.isEmpty && slotDiv && slotDiv.querySelector('iframe')) {
					const labelDiv = sponsorWrapperDiv.querySelector('.ad-label');
					labelDiv.style.display = 'block';
				}
			}
		};

		DFPManager.getGoogletag().then((googletag) => {
			if (typeof googletag !== 'undefined') {
				googletag.cmd.push(() => {
					googletag.pubads().addEventListener('slotRenderEnded', displaySponsorAd);
				});
			}
		});
	}, [router.asPath]);

	return (
		<Ad
			sizes={{ 'xs sm md lg xl': AdSizes.SPONSOR_LOGO }}
			htmlId={adId}
			wrapperClass={adWrapperClass}
			className={adId}
			adLabel={adLabel}
		/>
	);
}
